const STORAGE_KEY = 'upsales:session';

export type SessionIdentity = { userId: number; customerId: number };

let ownIdentity: SessionIdentity | null = null;
let listenerInstalled = false;

const serialize = (identity: SessionIdentity): string => `${identity.userId}:${identity.customerId}`;

export const shouldReloadForIncomingSession = (
	incoming: string | null,
	own: SessionIdentity | null
): boolean => {
	if (!incoming || !own) {
		return false;
	}
	return incoming !== serialize(own);
};

const onStorage = (event: StorageEvent): void => {
	if (event.key !== STORAGE_KEY) {
		return;
	}
	if (shouldReloadForIncomingSession(event.newValue, ownIdentity)) {
		window.location.reload();
	}
};

export const broadcastSessionEstablished = (identity: SessionIdentity): void => {
	ownIdentity = identity;
	localStorage.setItem(STORAGE_KEY, serialize(identity));
};

export const clearSessionIdentity = (): void => {
	ownIdentity = null;
	localStorage.removeItem(STORAGE_KEY);
};

export const installSessionSyncListener = (): void => {
	if (listenerInstalled) {
		return;
	}
	listenerInstalled = true;
	window.addEventListener('storage', onStorage);
};
